import React from "react";
import { BsStarFill, BsStarHalf, BsStar } from "react-icons/bs"

const websiteReviews = [
    {
        id: 1,
        name: "Adam L.",
        job: "Customer",
        review_title: "Great Service",
        desc: "Great service from AutoInsure! They was able to arrange delivery of the car to me in London, and return at Heathrow - very convenient.",
        rating: 4.5,
        rating_stars: <><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarHalf/></>,
        img: "images/customer_portraits/one.png"
    },
    {
        id: 2,
        name: "Zach N.",
        job: "Customer",
        review_title: "Thorough & Efficient",
        desc: "AutoInsure were very thorough and they made the renting process very simple and efficient. Fantastic service!",
        rating: 4.5,
        rating_stars: <><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarHalf/></>,
        img: "images/customer_portraits/two.png"
    },
    {
        id: 3,
        name: "Rachel H.",
        job: "Customer",
        review_title: "Would Recommend!",
        desc: "AutoInsure's cars are great, efficient and easy to get around in! Also communication was a total pleasure. Would absolutely recommend!!",
        rating: 5,
        rating_stars: <><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></>,
        img: "images/customer_portraits/three.png"
    },
    {
        id: 4,
        name: "Gabriel W.",
        job: "Customer",
        review_title: "Perfect for Travels",
        desc: "Great little car perfect for our travels! Will deffo book with AutoInsure in future. Very professional and has a nice selection of cars to choose from!",
        rating: 4,
        rating_stars: <><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStar/></>,
        img: "images/customer_portraits/four.png"
    },
    {
        id: 5,
        name: "Chloe S.",
        job: "Customer",
        review_title: "Fantastic Service!",
        desc: "Great little car to get around the UK! Highly recommended AutoInsure as a host! 10/10.",
        rating: 5,
        rating_stars: <><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></>,
        img: "images/customer_portraits/five.png"
    },
    {
        id: 6,
        name: "Matt M.",
        job: "Customer",
        review_title: "Great for Family Holidays",
        desc: "AutoInsure’s vehicle was perfect for our family holiday, and in excellent condition. Even more, his service and flexibility was outstanding",
        rating: 4.5,
        rating_stars: <><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarHalf/></>,
        img: "images/customer_portraits/six.png"
    },
    {
        id: 7,
        name: "Donnchadh K.",
        job: "Customer",
        review_title: "Nice Cars",
        desc: "Good little nippy car; clutch a bit short but nothing you can’t get used to!",
        rating: 5,
        rating_stars: <><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></>,
        img: "images/customer_portraits/seven.png"
    }
]

export default websiteReviews